// Hand a downloaded file to the browser (v1.3 ticket 22, owner ruling Q35).
//
// The portal fetches a stored file through the API (`/api/operations/download-docs`, responseType "blob") and gives it
// to the browser through a link it clicks. v1.2 added that link to <body> and never took it away, on Forms & FAQs, on
// the Service Request details page and on Operations' Update Master Data: each download left an empty, unnamed link on
// the page (a screen reader lists it; axe `link-name`). Tickets 14 and 21 fixed the first two in place; the three now
// share this one hand-over, so none can drift back.
/**
 * @param {Blob} blob    the file's content, as the API returned it
 * @param {string} name  the name the browser saves it under
 */
export function saveFile(blob, name) {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = name;
  document.body.appendChild(link);
  link.click();
  // The browser has the file once the link is clicked: nothing is left behind
  link.remove();
  window.URL.revokeObjectURL(url);
}
